<template>
  <div class="cart-container">
    <div class="cart-box">
      <div class="cart-title">{{ `购物车(全部${cartNum})`}}</div>
      <div class="cart-table-container">
        <el-table
           ref="cartTable"
          :data="tableData"
          style="width: 100%"
          header-align="center"
          header-row-class-name="order-table-header"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
          <el-table-column prop="info" label="商品信息" width="420">
            <template slot-scope="scope">
              <div class="order-item">
                <img :src="scope.row.sku.goods.image[0]" alt="" class="order-item-img" />
                <div>
                  <div class="order-item-name">{{ scope.row.sku.goods.name }}</div>
                  <div class="order-item-category" >
                    <span v-for="(value,key) in scope.row.sku.spec" :key="key" style="margin-right:4px;">
                      {{ `${key}:${value}` }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" align="center">
            <template slot-scope="scope">
              <div class="order-item-price">￥{{ scope.row.sku.price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量" align="center"  width="220">
             <template slot-scope="scope">
              <!-- max 库存最大值 -->
              <el-input-number
                v-model="scope.row.count"
                :min="0"
                :max="scope.row.sku.stock == -1 ? 9999 : scope.row.sku.stock"
                @change="value=>countChange(value,scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="金额"
            align="center"
          >
            <template slot-scope="scope">
              <div class="order-item-price primary">￥{{ scope.row.totalPrice }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
    </div>
    <div class="cart-total-container">
      <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="isAllCheck" @change="handleCheckAllChange">{{ checkLabel }}</el-checkbox>
      </div>
      <div class="cart-goods-container">
        <span class="cart-goods-num">
          已选择<span class="primary">{{ goodsNum }}</span>件商品
        </span>
        <span>
          总价:<span class="primary">￥{{ totalIncludeFreight }}</span>
        </span>
        <div class="settle-btn" @click="toSettle">去结算</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCartList, editCart } from "@/api/home"
import Decimal from "decimal.js"
import { mapState } from "vuex"

export default {
  data() {
    return {
      cartNum: 0,
      tableData: [],
      totalIncludeFreight:0,
      isAllCheck:false,//是否全选,
      selectionList:[],
      isIndeterminate:false
    };
  },
  created() {
    window.scrollTo(0,0)
    this.getCartList()
  },
  computed:{
    ...mapState("company",['company']),
    checkLabel() {
      return this.isAllCheck ? '取消全选' : '全选'
    },
    goodsNum() {
      return this.selectionList.length
    }
  },
  methods: {
    toSettle() {
      if(!this.selectionList.length) {
        this.$message('您还没有选择商品哦~')
        return
      }
      const goodsInfo = this.selectionList.map(item=>{
        return {
          name:item.sku.goods.name,
          count:item.count,
          skuId:item.sku.id,
          spec:item.sku.spec,
          img:item.sku.goods.image.length ? item.sku.goods.image[0] : '',
          price:item.sku.price,
          stock:item.sku.stock,
          isCart:1
        }
      })
      console.log(goodsInfo,'goodsInfo')
      localStorage.setItem('goodsInfo',JSON.stringify(goodsInfo))
      this.$router.push({
          name: 'ConfirmOrder'
      })
    },
    handleCheckAllChange(value) {
      this.selectionList = value ? this.tableData : [];
      if(value) {
        this.$refs.cartTable.toggleAllSelection()
      }else {
        this.$refs.cartTable.clearSelection()
      }
      this.isIndeterminate = false;
      this.getTotalIncludeFreight()
    },
    handleSelectionChange(value) {
      this.selectionList = value;
      let checkedCount = value.length;
      this.isAllCheck = checkedCount === this.tableData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      // 计算总价
      this.getTotalIncludeFreight()
    },
    getTotalIncludeFreight() {
      let totalPrice = this.selectionList.reduce((prev, cur, index)=> {
        return new Decimal(prev).add(new Decimal(cur.totalPrice)).toNumber()
      },0) 
      this.totalIncludeFreight = totalPrice
      if(this.company.free_delivery_min) {
        if(totalPrice < +this.company.free_delivery_min ) {
          this.totalIncludeFreight  = new Decimal(this.totalIncludeFreight).add(new Decimal(this.company.delivery_fee)).toNumber() 
        }
      }
    },
    countChange(value,item) {
      editCart({
        id: item.id,
        count: value
      }).then(res=> {
        if(res.code == 10000) {
          this.getCartList()
        } else {
          this.$message.error(res.msg)
        }
      })
      // item.totalPrice = new Decimal(item.sku.price).mul(new Decimal(value))
      // const temp = this.selectionList.find(select=>select.id === item.id) //该项是否已被勾选
      // if(temp) {
      //   this.getTotalIncludeFreight()
      // }
    },
    async getCartList(){
       const {data} = await getCartList()
       this.tableData = data
       this.cartNum = data.length
       this.tableData.forEach(item=>{
        item.totalPrice = new Decimal( item.sku.price).mul(new Decimal( item.count)).toNumber()
       })
       console.log(this.tableData)
    }
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";

.cart-container {
  margin-top: 25px;
}
.cart-box {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 0 47px;
  box-sizing: border-box;
}
.cart-title {
  font-size: 20px;
  font-weight: 600;
  color: @words;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 16px;
  padding-top: 31px;
}
.cart-table-container {
  margin-top: 20px;
}
/deep/.el-table__cell.is-leaf {
  text-align: center;
}
/deep/.el-table thead {
  font-size: 16px;
  color: @words !important;
}
.order-item {
  display: flex;
}
.order-item-img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  margin-right: 26px;
}
.order-item-name {
  font-size: 14px;
  font-weight: 600;
  color: @words;
  .line-clamp();
}
.order-item-category {
  font-size: 12px;
  font-weight: 400;
  color: @tipwords;
  margin-top: 21px;
  .line-clamp(1);
}
.order-item-price {
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.order-item-count {
    font-size: 14px;
    font-weight: 600;
    color: @words;
}
.order-item-price.primary,
.primary {
    color:@primary;
}
.cart-total-container {
  width: 1200px;
  height: 131px;
  background: #FFFFFF;
  border-radius: 20px;
  margin: 55px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left:46px;
  box-sizing: border-box;
}
/deep/ .el-checkbox__label{
  font-size: 16px;
  font-weight: 600;
  color: @words;
}
.cart-goods-container {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.cart-goods-num {
  margin-right: 8px;
}
.settle-btn {
  width: 191px;
  height: 64px;
  background: @primary;
  border-radius: 14px;
  font-size: 20px;
  font-weight: 600;
  color: #FFFFFF;
  text-align: center;
  line-height: 64px;
  margin-right: 29px;
  margin-left: 32px;
  cursor: pointer;
}
</style>